import { config } from '../config'

export function devModeLog(...args: unknown[]) {
  if (config.mode === 'development') {
    console.log(...args)
  }
}
